import { Schema } from "effect";
export const ConnectedNoteDetails = Schema.Struct({
    newTaskId: Schema.optional(Schema.String),
    newEventId: Schema.optional(Schema.String),
    modelUsed: Schema.optional(Schema.String),
    diffNoteToModel: Schema.optional(Schema.String),
    inMeetingNotesUsed: Schema.optional(Schema.Boolean),
});
export const InterviewMetrics = Schema.Struct({
    iId: Schema.String,
    ConnectedNoteDetails: Schema.optional(Schema.String),
    ConnectedUpdateType: Schema.optional(Schema.String),
});
export const InterviewMetricsNotesResponse = Schema.Struct({
    activityTypeObject: Schema.optional(Schema.String),
    activityType: Schema.optional(Schema.String),
    recruiterNotes: Schema.optional(Schema.String),
    summary: Schema.optional(Schema.String),
    editable: Schema.Boolean,
});
